import React from 'react';
import { Map, ShieldCheck, MessageSquare } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-slate-900 text-white" data-id="element-195">
      <div className="container mx-auto px-4" data-id="element-196">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-197">
          <span className="text-blue-400 font-semibold tracking-wider uppercase text-sm" data-id="element-198">
            El Método
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-6" data-id="element-199">
            Mapa Antipánico 3C
          </h2>
          <p className="text-slate-300 text-lg" data-id="element-200">
            Este producto no te vende motivación. Te entrega un sistema para
            recuperar el control.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-201">
          {/* Step 1: Claridad */}
          <div className="relative group" data-id="element-202">
            <div className="absolute inset-0 bg-blue-600/20 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform" data-id="element-203"></div>
            <div className="relative bg-slate-800 p-8 rounded-2xl border border-slate-700 h-full" data-id="element-204">
              <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-blue-900/50" data-id="element-205">
                <Map className="w-8 h-8 text-white" data-id="element-206" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-207">1. Claridad</h3>
              <p className="text-blue-200 text-sm mb-4 font-medium" data-id="element-208">
                Inventario + Ranking Real
              </p>
              <ul className="space-y-3 text-slate-300" data-id="element-209">
                <li className="flex items-start gap-2" data-id="element-210">
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2" data-id="element-211"></span>
                  <span data-id="element-212">
                    Inventario total en una sola hoja (sin esconder nada).
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-213">
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2" data-id="element-214"></span>
                  <span data-id="element-215">
                    Ranking de prioridades real (no pagar al que grita más).
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Step 2: Contención */}
          <div className="relative group" data-id="element-216">
            <div className="absolute inset-0 bg-blue-600/20 rounded-2xl transform -rotate-3 group-hover:-rotate-6 transition-transform" data-id="element-217"></div>
            <div className="relative bg-slate-800 p-8 rounded-2xl border border-slate-700 h-full" data-id="element-218">
              <div className="w-14 h-14 bg-indigo-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-indigo-900/50" data-id="element-219">
                <ShieldCheck className="w-8 h-8 text-white" data-id="element-220" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-221">2. Contención</h3>
              <p className="text-indigo-200 text-sm mb-4 font-medium" data-id="element-222">
                Presupuesto + PMV
              </p>
              <ul className="space-y-3 text-slate-300" data-id="element-223">
                <li className="flex items-start gap-2" data-id="element-224">
                  <span className="w-1.5 h-1.5 bg-indigo-500 rounded-full mt-2" data-id="element-225"></span>
                  <span data-id="element-226">
                    Presupuesto quincenal de supervivencia (realista).
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-227">
                  <span className="w-1.5 h-1.5 bg-indigo-500 rounded-full mt-2" data-id="element-228"></span>
                  <span data-id="element-229">
                    Plan de Pago Mínimo Viable (PMV) que puedas sostener.
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Step 3: Convenios */}
          <div className="relative group" data-id="element-230">
            <div className="absolute inset-0 bg-blue-600/20 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform" data-id="element-231"></div>
            <div className="relative bg-slate-800 p-8 rounded-2xl border border-slate-700 h-full" data-id="element-232">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mb-6 shadow-lg shadow-teal-900/50" data-id="element-233">
                <MessageSquare className="w-8 h-8 text-white" data-id="element-234" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-235">3. Convenios</h3>
              <p className="text-teal-200 text-sm mb-4 font-medium" data-id="element-236">
                Guiones + Límites
              </p>
              <ul className="space-y-3 text-slate-300" data-id="element-237">
                <li className="flex items-start gap-2" data-id="element-238">
                  <span className="w-1.5 h-1.5 bg-teal-500 rounded-full mt-2" data-id="element-239"></span>
                  <span data-id="element-240">Scripts listos para WhatsApp (firme y corto).</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-241">
                  <span className="w-1.5 h-1.5 bg-teal-500 rounded-full mt-2" data-id="element-242"></span>
                  <span data-id="element-243">Reglas para negociar sin pánico y por escrito.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}